import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import anime from 'animejs';

import { Link } from '../Link';

class Component extends React.Component {
  static displayName = 'Brand';

  static propTypes = {
    theme: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    energy: PropTypes.object.isRequired,
    audio: PropTypes.object.isRequired,
    sounds: PropTypes.object.isRequired,
    className: PropTypes.any,
    link: PropTypes.string,
    hover: PropTypes.bool,
    stableTime: PropTypes.bool,
    onEnter: PropTypes.func,
    onExit: PropTypes.func,
    onLinkStart: PropTypes.func,
    onLinkEnd: PropTypes.func,
    onClick: PropTypes.func
  };

  static defaultProps = {
    link: '/'
  };

  constructor () {
    super(...arguments);

    const { energy, stableTime } = this.props;

    if (!stableTime) {
      energy.updateDuration({ enter: 820 });
    }
  }

  componentWillUnmount () {
    anime.remove(this.wordmarkElement);
    anime.remove(this.textElement);
  }

  enter () {
    const { energy, sounds, stableTime, onEnter } = this.props;
    const textLength = this.textElement ? this.textElement.getComputedTextLength() * 2 : 900;
    const drawDuration = stableTime ? energy.duration.enter : Math.max(600, energy.duration.enter);

    sounds.logo.play();

    anime.set(this.wordmarkElement, {
      opacity: 1,
      translateY: stableTime ? 0 : 8
    });

    anime.set(this.textElement, {
      strokeDasharray: textLength,
      strokeDashoffset: textLength,
      opacity: 1,
      fillOpacity: 0
    });

    anime({
      targets: this.textElement,
      easing: 'linear',
      strokeDashoffset: [textLength, 0],
      duration: drawDuration,
      complete: () => {
        onEnter && onEnter();
      }
    });

    anime({
      targets: this.textElement,
      easing: 'easeOutCubic',
      fillOpacity: [0, 1],
      delay: drawDuration * 0.65,
      duration: drawDuration * 0.35
    });

    if (!stableTime) {
      anime({
        targets: this.wordmarkElement,
        easing: 'easeOutCubic',
        translateY: [8, 0],
        duration: energy.duration.enter
      });
    }
  }

  exit () {
    const { energy, sounds, onExit } = this.props;

    sounds.fade.play();

    anime({
      targets: [this.wordmarkElement, this.textElement],
      easing: 'easeInCubic',
      duration: energy.duration.exit,
      opacity: 0,
      translateY: -12,
      complete: () => {
        onExit && onExit();
      }
    });
  }

  render () {
    const {
      theme,
      classes,
      energy,
      audio,
      sounds,
      className,
      link,
      hover,
      stableTime,
      onEnter,
      onExit,
      onLinkStart,
      onLinkEnd,
      onClick,
      ...etc
    } = this.props;

    return (
      <h1 className={cx(classes.root, hover && classes.hover, className)} {...etc}>
        <Link
          className={classes.link}
          href={link}
          title='Melih Emik Logo'
          onClick={onClick}
          onLinkStart={onLinkStart}
          onLinkEnd={onLinkEnd}
        >
          <svg
            className={classes.wordmark}
            ref={ref => (this.wordmarkElement = ref)}
            viewBox='0 0 900 110'
            role='img'
            aria-label='Melih Emik'
            xmlns='http://www.w3.org/2000/svg'
            onMouseEnter={() => sounds.hover.play()}
          >
            <text
              className={classes.wordmarkText}
              ref={ref => (this.textElement = ref)}
              x='450'
              y='86'
              textAnchor='middle'
            >
              Melih Emik
            </text>
          </svg>
        </Link>
      </h1>
    );
  }
}

export { Component };
